// please align with existing page
export const pageSet = {
  default: "default",
  changes: "changes",
  horseformername: "horseformername",
  jkcscheduledrides: "jkcscheduledrides",
  jockeyranking: "jockeyranking",
  jockeysrides: "jockeysrides",
  summary: "summary",
  tncentries: "tncentries",
  trainerranking: "trainerranking",
  trainersentries: "trainersentries",
  speedguide: "speedguide",
  formguide: "formguide",
  speedprotutorial: "speedprotutorial",
  weather: "weather",
};
